import { render, staticRenderFns } from "./PlayerRating.vue?vue&type=template&id=f699f402&scoped=true"
import script from "./PlayerRating.vue?vue&type=script&lang=js"
export * from "./PlayerRating.vue?vue&type=script&lang=js"
import style0 from "./PlayerRating.vue?vue&type=style&index=0&id=f699f402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f699f402",
  null
  
)

export default component.exports